import React from 'react';
// Components
import ManageExperienceTable from 'components/common/ManageExperienceTable';

const ManageContentCreatorProducts: React.FC = () => {
  return <ManageExperienceTable />;
};

export default ManageContentCreatorProducts;
